import axios from "axios";

export const uploadFile = async (uploadURL, fileToUpload, authHeaders) => {
    try {
        await axios.put(uploadURL, fileToUpload, {
            headers: {
                'Content-Type': fileToUpload.type,
                ...authHeaders
            }
        });
        // console.log("Upload success:", res.status);
        return { status: true };
    } catch (err) {
        console.error("Upload failed:", err.message);
        throw err;  // <-- THROW error here
    }
};
